<form [formGroup]="settingForm" class="example-form settings-form">

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.siteReferralForm.title' | translate}}</mat-label>
        <input formControlName="title" matInput type="text" required>
        <mat-error *ngIf="settingForm.controls.title.errors?.required"> {{ 'FORM_VALIDATION.REQUIRED' | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field class="w-100 mb-2">
        <mat-label>{{'FORM.siteReferralForm.siteReferralURL' | translate}}</mat-label>
        <input formControlName="siteReferralURL" matInput type="text" required>
        <!-- <span matPrefix>https://</span> -->
        <mat-error *ngIf="settingForm.controls.siteReferralURL.errors?.required"> {{ 'FORM_VALIDATION.REQUIRED' | translate }}</mat-error>
        <mat-error *ngIf="settingForm.controls.siteReferralURL.errors?.urlVlaid"> {{ 'FORM_VALIDATION.urlVlaid' | translate }} </mat-error>
        <mat-hint>{{'FORM.siteReferralForm.hint_URL' | translate}}</mat-hint>
    </mat-form-field>

    <mat-slide-toggle class="example-margin slide-toggle-text" formControlName="useAsDefault">
        {{'FORM.siteReferralForm.useAsDefault' | translate}}
    </mat-slide-toggle>

    <div>
        <button [disabled]="settingForm.invalid || updateRight" class="my-4 first-stt-btn w-100" mat-raised-button type="submit" (click)="onSubmit()">
            {{ 'FORM.BTN_SAVE' | translate }}
        </button>
        <button [disabled]="isCreate || deleteRight" class="w-100 second-stt-btn mb-2" style="float:inline-end;" mat-button (click)="onDelete()">
            {{ 'FORM.BTN_DELETE' | translate }}
        </button>
    </div>

    
</form>